import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

export default class LightBoxImage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      photoIndex: props.currentPhoto
    };
  }

  componentWillReceiveProps = nextProps => {
      this.setState({photoIndex: nextProps.currentPhoto})
  }

  render() {
    const { isOpen, images, onClose } = this.props;
    const  { photoIndex } = this.state;

    return (
      <div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={onClose}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }
            reactModalStyle={{overlay: {zIndex: 3000}}}
          />
        )}
      </div>
    );
  }
}